import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopyright } from "@fortawesome/pro-solid-svg-icons/faCopyright";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { RWA_URLS } from "../../consts";
import { Anchor } from "../Anchor";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { Routes } from "~/routes";
import { Link } from "../Link";

// // // //

/**
 * Renders Icon link to social media sites
 */
function SocialLink(props: {
    href: string;
    label: string;
    icon: IconDefinition;
}) {
    const { href, label, icon } = props;
    return (
        <Anchor
            openInNewTab
            href={href}
            ariaLabel={label}
            analyticsLabel={`Social Link - ${label}`}
            className="text-slate-500 hover:text-slate-700 transition-colors"
        >
            <FontAwesomeIcon className="h-4" icon={icon} />
        </Anchor>
    );
}

interface HrefProps {
    href: string;
    onClick?: never;
}

interface OnClickProps {
    href?: never;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
type ClickableProps = HrefProps | OnClickProps;

/**
 * Renders a single link to misc. external sites
 */
function FooterLink(props: ClickableProps & { label: string }) {
    const { href, label, onClick } = props;

    if (onClick) {
        return (
            <button
                aria-label={label}
                className="text-slate-500 hover:text-slate-700 transition-colors"
                rel="noreferrer"
                draggable={false}
                onClick={onClick}
            >
                {label}
            </button>
        );
    }

    return (
        <Anchor
            openInNewTab
            href={href}
            ariaLabel={label}
            analyticsLabel={`FooterLink - ${label}`}
            className="text-slate-500 hover:text-slate-700 transition-colors"
        >
            {label}
        </Anchor>
    );
}

/**
 * Renders a single link to misc. external sites
 */
// function FooterLinkInternal(props: { label: string; href: string }) {
//     const { href, label } = props;

//     return (
//         <Link
//             href={href}
//             ariaLabel={label}
//             analyticsLabel={`FooterLink - ${label}`}
//             className="text-slate-500 hover:text-slate-700 transition-colors"
//         >
//             {label}
//         </Link>
//     );
// }

/**
 * Renders links to FAQs / Blog / Terms / Policy
 */
function FooterLinks() {
    return (
        <div className="flex gap-6 pb-4 flex-wrap justify-center md:pb-0 md:flex-nowrap md:justify-normal">
            <FooterLink label="Documentation" href={RWA_URLS.docs} />

            <Link
                openInNewTab
                href={Routes.blog}
                analyticsLabel={"FooterLink - Blog"}
                className="text-slate-500 hover:text-slate-700 transition-colors"
            >
                Blog
            </Link>

            <FooterLink label="Careers" href={RWA_URLS.careers} />
            {/* <FooterLink label="Research" href={RWA_URLS.docs} /> */}
            {/* <FooterLink label="Docs" href={RWA_URLS.docs} /> */}

            <Link
                openInNewTab
                href={Routes.termsOfUse}
                analyticsLabel={"FooterLink - Terms of Use"}
                className="text-slate-500 hover:text-slate-700 transition-colors"
            >
                Terms of Use
            </Link>

            <Link
                openInNewTab
                href={Routes.privacyPolicy}
                analyticsLabel={"FooterLink - Privacy Policy"}
                className="text-slate-500 hover:text-slate-700 transition-colors"
            >
                Privacy Policy
            </Link>
        </div>
    );
}

/**
 * Renders "All Rights Reserved" notice
 */
function CompanyInfo() {
    return (
        <p className="text-slate-500 flex flex-col md:flex-row items-center pb-2 md:pb-0 gap-2 border-b border-slate-500 md:border-none">
            <span className="flex items-center gap-1.5 ">
                <FontAwesomeIcon className="h-4" icon={faCopyright} />
                <span>RWA.xyz</span>
            </span>
            <span>All Rights Reserved</span>
        </p>
    );
}

// // // //

export function Footer() {
    return (
        <div className="select-none font-light text-sm px-8 lg:px-0 flex flex-col lg:flex-row items-center justify-between py-6 md:gap-3 lg:gap-0">
            <CompanyInfo />
            <div className="flex flex-col md:flex-row space-x-0 md:space-x-6 mt-2 md:mt-0 items-center">
                {/* NOTE - this is commented out until we nail down what links are going to go here */}
                <FooterLinks />
                {/* <span className="text-slate-500">|</span> */}
                <SocialLink
                    icon={faXTwitter}
                    label="Link to rwa.xyz Twitter"
                    href={RWA_URLS.twitter}
                />
                <div className="w-8" />
            </div>
        </div>
    );
}
